import { Grid } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { toast } from "react-toastify";
import { useState } from "react";

import FileInputButton from "@/components/fileInputButton";
import { getBase64 } from "@/utils/utils";
import serviceRebateUsina from "@/services/serviceRebateUsina";

export default function ImportRebate({ onClose, onSuccess }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileBase64, setSelectedFileBase64] = useState("");

    const [isDisable, setDisable] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const clearFile = () => {
        setSelectedFile(null);
        setSelectedFileBase64("");
    };

    const handleFileInput = (e: any) => {
        const extension = e.target.files[0].name.split(".").pop().toLowerCase();

        if (["csv"].includes(extension)) {
            setSelectedFile(e.target.files[0]);

            const size = e.target.files[0].size / 1024 / 1024;

            if (size > 10) {
                toast.error("O tamanho do arquivo selecionado não pode ser maior do que 10MB");
                clearFile();
            }

            getBase64(e.target.files[0]).then((result) => {
                setSelectedFileBase64(result);
            });
        } else {
            toast.error("O arquivo selecionado é inválido. É necessário anexar a fatura no formato PDF ou ZIP (XML)!");
            clearFile();
        }
    };

    const onSubmit = () => {
        setDisable(true);
        setLoading(true);

        if (!selectedFile || !selectedFileBase64) {
            toast.error("É necessário anexar o arquivo (CSV) do Rebate.");
            setDisable(false);
            setLoading(false);
        } else {
            const chargeValues = {
                fileBase64: selectedFileBase64.replace("data:text/csv;base64,", ""),
            };
            serviceRebateUsina
                .import(chargeValues)
                .then((result) => {
                    if (result) {
                        setDisable(false);
                        setLoading(false);
                        toast.info("O Arquivo será carregado, por favor aguarde.");
                        onClose(true);
                        onSuccess();
                    }
                })
                .finally(() => {
                    clearFile();
                });
        }
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open
        >
            <DialogTitle>
                Importar Rebate
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        onClose();
                    }}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                        <FileInputButton accept="text/csv" onChange={handleFileInput} selectedFile={selectedFile} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                <LoadingButton
                    onClick={onClose}
                    color="warning"
                    variant="contained"
                    style={{ width: "159px", height: "44px" }}
                >
                    Cancelar
                </LoadingButton>
                <LoadingButton
                    onClick={onSubmit}
                    disabled={isDisable}
                    loading={isLoading}
                    color="primary"
                    variant="contained"
                    style={{ width: "159px", height: "44px" }}
                >
                    Carregar
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
